module.exports = __webpack_public_path__ + "img/result_head_right.143bae6e.png";